import React from 'react';
import { HandoffSnapshot } from '../../../handoff-hub.types';
import { HandoffChecklistV2 } from '../edit-handoff/handoff-checklist-v2/handoff-checklist-v2';
import { mapSnapshotMetricsToWieChecklist } from '../edit-handoff/wie-handoff/wie-handoff.helpers';

type Props = {
  snapshotData: HandoffSnapshot;
};

export const WieSnapshotView = ({ snapshotData }: Props) => {
  const mappedMetrics = mapSnapshotMetricsToWieChecklist(snapshotData.metrics);

  return (
    <HandoffChecklistV2
      metrics={mappedMetrics}
      notes={snapshotData.officeExperience || ''}
      readOnly
      showWhereToFix={false}
    />
  );
};
